import { createRouter, createWebHistory , createWebHashHistory} from 'vue-router'


const routes = [
  {
    // 首页
    path: '/',
    name: 'page',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PageView.vue')
  },
  {
    // 关于我们
    path: '/aboutus',
    name: 'aboutus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutusView.vue')
  },
  {
    // 产品介绍
    path: '/Introd',
    name: 'Introd',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductsView.vue'),
    children: [
      {
        // 产品介绍 客服热线
        path: '/Introd/hotl',
        name: 'hotl',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Hotline.vue')
      },
      {
        // 产品介绍 工单中心
        path: '/Introd/order',
        name: 'order',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/WorkSystem.vue')
      },
      {
        // 产品介绍 ai系统
        path: '/Introd/artif',
        name: 'artif',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Aisystem.vue')
      },
      {
        // 产品介绍  综合管理系统
        path: '/Introd/compreh',
        name: 'compreh',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Comprehensive.vue')
      },
      {
        // 产品介绍 智慧水厂 
        path: '/Introd/smart',
        name: 'smart',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Smartwater.vue')
      },
      {
        // 产品介绍 农饮水系统 
        path: '/Introd/drink',
        name: 'drink',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Drinkingwater.vue')
      },
      {
        // 产品介绍 设备管理系统 
        path: '/Introd/device',
        name: 'device',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Device.vue')
      },
      {
        // 产品介绍 舆情管理系统 
        path: '/Introd/public',
        name: 'public',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Public.vue')
      },
      {
        // 产品介绍 智能预警平台
        path: '/Introd/plat',
        name: 'plat',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../components/Platform.vue')
      }]

  },
  {
    // 成功案例
    path: '/cases',
    name: 'cases',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/SuccescasesView.vue')
  },
  {
    // 联系我们
    path: '/cont',
    name: 'cont',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
